import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

import { theme } from '@/theme';

import type { CardProps } from '../../types';

import * as S from './PromoType.styles';

export const PromoCard = ({
  cardText,
  className,
  textAlignment,
  textColor,
  type,
  visibleInDesktop,
  visibleInMobile,
}: CardProps) => {
  const htmlString = cardText
    ? documentToHtmlString(cardText.json).replace(/\n/g, '<br />')
    : '';

  const renders = () => {
    if (type === 'promoTitle') {
      return (
        cardText && (
          <S.Title
            $color={textColor ?? theme.colors.default}
            $textAlignment={textAlignment ?? 'left'}
            dangerouslySetInnerHTML={{
              __html: htmlString,
            }}
            data-testid='text'
          />
        )
      );
    } else {
      return (
        cardText && (
          <S.Text
            $color={textColor ?? theme.colors.default}
            $textAlignment={textAlignment ?? 'left'}
            dangerouslySetInnerHTML={{
              __html: htmlString,
            }}
            data-testid='text'
          />
        )
      );
    }
  };

  return (
    <S.Wrapper
      $visibleInDesktop={visibleInDesktop}
      $visibleInMobile={visibleInMobile}
      className={className}
    >
      {renders()}
    </S.Wrapper>
  );
};
